import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import ScopeListsManager from '~/javascript/components/negative_keywords/scope_lists_manager.vue'

export default class extends Controller {
  static values = {
    accountId: String,
    csrfToken: String
  }

  connect() {
    this.vue = createApp(ScopeListsManager, {
      scope: 'account',
      accountId: this.accountIdValue,
      csrfToken: this.csrfTokenValue
    })
    this.vue.mount(this.element)
  }

  disconnect() { this.vue?.unmount() }
}
